import React from 'react';
import {Layout, ProgressCircle, ProgressCircleProps} from '@di-nxt/components';

type Props = ProgressCircleProps & {
  showDot?: boolean;
};

export const ProgressCircleWithDot: React.FC<Props> = ({
  showDot = false,
  size,
  ...progressProps
}) => {
  return (
    <Layout>
      <ProgressCircle size={size} {...progressProps} />
      {showDot && (
        <Layout
          position="absolute"
          right={dotLayout[size].offset}
          bottom={dotLayout[size].offset}
          backgroundColor="content_negative_default"
          width={dotLayout[size].size}
          height={dotLayout[size].size}
          borderColor={'background_mono_primary'}
          borderWidth="2"
          borderRadius="9999"
          borderStyle="solid"
        />
      )}
    </Layout>
  );
};

type DotLayout = {
  [size in ProgressCircleProps['size']]: {
    size: number;
    offset: number;
  };
};

const dotLayout: DotLayout = {
  '16': {
    size: 4,
    offset: -1,
  },
  '28': {
    size: 6,
    offset: 0,
  },
  '40': {
    size: 8,
    offset: 1,
  },
};
